import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RecipientUser } from "../manage_tags_modal.utils";
import css from "./recipient_option.module.scss";

type RecipientOptionProps = {
  recipient: RecipientUser;
};

export const RecipientOption = ({ recipient }: RecipientOptionProps) => {
  const { t } = useTranslation(["activities", "translation"]);

  const fullName = getProfileName(recipient);

  const roleLabels = recipient.role.map((role) => t(`activities:show.parts.${role}`));

  const finalRoleLabel = useMemo(() => {
    if (roleLabels.length === 1) {
      return roleLabels[0];
    }

    const lastRoleLabel = roleLabels.pop();
    const otherRoleLabels = roleLabels.join(", ");

    return t("translation:common.and", {
      section1: otherRoleLabels,
      section2: lastRoleLabel
    });
  }, [roleLabels, t]);

  return (
    <Stack className={css.root}>
      <Inline justifyContent="space-between">
        <Typography variant="labelBold">{fullName}</Typography>
        <Typography variant="labelRegular" clipOverflow>
          {finalRoleLabel}
        </Typography>
      </Inline>

      <Typography variant="labelRegular">{recipient.email}</Typography>
    </Stack>
  );
};
